// 主号通路接口
// https://iwiki.woa.com/pages/viewpage.action?pageId=1655171439
import { isPrivate } from 'src/config/private';
import Gateway from 'src/utils/Gateway';

let cacheData;

let isLoading = false;
const resolveTaskArr = [];

function handleResolveTask(res) {
    resolveTaskArr.forEach((resolve) => {
        resolve(res);
    });
}

export function getKfuinChannels() {
    return new Promise((resolve) => {
        if (typeof cacheData !== 'undefined') {
            resolve(cacheData);
            return;
        }

        resolveTaskArr.push(resolve);

        if (isLoading) {
            return;
        }

        isLoading = true;

        Gateway.get('/v1/basic.privilege.func_privilege.FuncPrivilege/KfuinChannels')
            .then((data) => {
                const { channels = [] } = data || {};

                handleResolveTask(channels);
                cacheData = channels;
                isLoading = false;
            })
            .catch(() => {
                handleResolveTask([]);
                isLoading = false;
            });
    });
}

export function hasQQChannel() {
    // 私有化没有QQ通路
    if (isPrivate) {
        return Promise.resolve(false);
    }

    return getKfuinChannels().then(channels => channels.some(id => id === 1 || id === 2));
}
